import Api from "@/services/Api";

export default {
  createSong(params) {
    return Api.post(`/song`, {
      ...params
    });
  },
  getSong(params) {
    return Api.get(`/song/${params.songId}`);
  },
  getSongForEdit(params) {
    const sendParams = params.removeNotes ? { removeNotes: true } : {};
    return Api.get(`/song/edit/${params.songId}`, {
      params: sendParams
    });
  },
  getUserSongs(params) {
    return Api.get(`/user/songs`, {
      params: {
        query: params.query ? params.query : null,
        page: params.page ? params.page : 1,
        perPage: params.perPage ? params.perPage : 20,
        sort: params.sort ? params.sort : null
      }
    });
  },
  getSongs(params) {
    return Api.get(`/search/songs`, {
      params: {
        query: params.query ? params.query : null,
        page: params.page ? params.page : 1,
        perPage: params.perPage ? params.perPage : 20,
        sort: params.sort ? params.sort : null
      }
    });
  },
  getSongsForTag(params) {
    return Api.get(`/search/songs/by_tag`, {
      params: {
        query: params.query,
        page: params.page ? params.page : 1,
        perPage: params.perPage ? params.perPage : 20
      }
    });
  },
  getTagHeader(params) {
    return Api.get(`/featured_tags/find`, {
      params: {
        tag: params.tag ? params.tag : null
      }
    });
  },
  getFeaturedTags() {
    return Api.get("/featured_tags");
  },
  postTrackedSongs(params) {
    return Api.post(`/track_songs`, params);
  },
  copySong(songId) {
    return Api.post(`/song/${songId}/copy`);
  },
  postSaveSong(params) {
    return Api.post(`/user/save/${params.songId}`);
  },
  postArchiveSong(songId) {
    return Api.post(`/song/archive/${songId}`);
  },
  putSaveSong({ songId, songName, artistName, tags, isPrivate = false }) {
    return Api.put(`/song/${songId}`, {
      songName,
      artistName,
      tags,
      private: isPrivate
    });
  },
  getNames() {
    return Api.get(`/user/generate_names`);
  },
  postBuySong(stripeToken, email, legalName, songId) {
    return Api.post("/buy_song", {
      stripeToken,
      email,
      legal_name: legalName,
      song_id: songId
    });
  },
  postClaimSong(ownershipCode, email, legalName, songId) {
    return Api.post("/claim_song", {
      ownershipCode,
      email,
      legal_name: legalName,
      song_id: songId
    });
  },
  postClaimSongWithCredits(email, legalName, songId) {
    return Api.post("/claim_song", {
      useCredits: true,
      email,
      legal_name: legalName,
      song_id: songId
    });
  },
  downloadSong(songId, type, tag) {
    return Api.get(
      `/user_download_song?song_id=${songId}&type=${type}&tag=${tag}`
    );
  },
  getHomepageTracks() {
    return Api.get("/homepage_tracks");
  },
  createVocal(songId, vocalFileId, autoVocal, emphasis, options) {
    return Api.post(`/song/vocal`, {
      songId,
      vocalFileId,
      autoVocal,
      emphasis,
      options
    });
  },
  deleteVocal(songId) {
    return Api.delete(`/song/${songId}/vocal`);
  },
  getTags(query) {
    return Api.get(`/search/songs/tags`, { params: { query } });
  },
  requestWav(songId) {
    return Api.post(`/song/${songId}/wav`);
  },
  getWavStatus(songId) {
    return Api.get(`/song/${songId}/wav/ready`);
  }
};
